// English language pack
export default {
  // App.vue - Navigation
  nav: {
    home: 'Home',
    about: 'About',
    case: 'Product',
    team: 'Team',
    culture: 'Vision',
    recruit: 'Join Us',
    contact: 'Contact Us',
    language: '中文',
  },

  // App.vue - Footer
  footer: {
    aboutTitle: 'About Us',
    companyProfile: 'Company Profile',
    projectCase: 'Project Cases',
    patentCert: 'Patent Certificate',
    joinTitle: 'Join Us',
    zhilian: 'Zhaopin Recruitment',
    boss: 'Boss Direct Recruitment',
    contactTitle: 'Contact Us',
    servicePhone: 'Service Line',
    companyAddress: 'Company Address',
    businessCooperation: 'Business Cooperation',
    qrcode: 'Scan the QR code to follow Forcartech official account',
    beian1: '鄂公网安备42011302001009号',
    beian2: '鄂ICP备19018302号-1',
  },

  // HomeView.vue - Homepage
  home: {
    hero: {
      line1: '',
      line2: 'Our mission',
      line3: '',
    },
    heroDesc: '',
    // hero mission text (special layout for EN)
    heroMission1: 'is to establish ourselves as a premier global leader in automotive technology, excelling in the creation and innovation of technical writing, special tools and computer software for exceptional after-sales service.',
    heroMission2: 'We are committed to setting new standards in research, development, and production, propelling the automotive industry forward with our cutting-edge solutions.',
    // Cert cards
    certTitle1: 'High-tech Certification',
    certDesc1: "We are honored to be recognized on the Hubei Province's official list of high-tech enterprise, having achieved the esteemed High-tech Enterprise Certification.",
    certTitle2: 'Multiple Patents',
    certDesc2: 'Years of hard work and innovation have resulted in multiple patents and software copyrights.',
    certTitle3: 'ISO9001 Certifications',
    certDesc3: 'We have been consecutively certified as an ISO 9001 quality management systems company for 10 years.',
    // Video section
    videoTitle: 'Our Latest Successful Projects',
    videoDesc: 'Tell stories with real cases',
    videoItem1Title: '3D CG animation',
    videoItem1Desc: 'Yingche Technology',
    videoItem2Title: '3D CG animation',
    videoItem2Desc: 'ZEEKR 001',
    videoItem3Title: '3D CG and Realistic Shooting blended Instructional Video',
    videoItem3Desc: 'NEW 2024 JMC Grand Avenue Raptor 2.3L Turbo',
    videoItem4Title: 'Instructional Video Production',
    videoItem4Desc: 'NEW 2024 JMC Grand Avenue Raptor 2.3L Turbo',
    videoItem5Title: 'Instruction Video Filming',
    videoItem5Desc: 'VOYAH FREE',
    // 3D interaction
    interaction3d: 'Enhanced User Experience with Interactive 3D',
    interaction3dDesc: '"Our latest small-sized dynamic and engaging presentations or displays leverage 3D graphics and interactive, enabling users to explore, manipulate, and interact with content in a three-dimensional environment,offering an immersive and captivating experience."',
    // Case studies
    caseTitle: 'Case Studies',
    caseDesc: 'Weaving a narrative with our products',
    caseItem1Title: 'User Manual',
    caseItem1Desc: 'Developed "User Manuals" for a total of 86 vehicle models',
    caseItem2Title: 'Maintenance Manual',
    caseItem2Desc: 'Developed "Maintenance Manual" for a total of 64 models',
    caseItem3Title: 'Disassembly Manual',
    caseItem3Desc: 'We have developed comprehensive Disassembly Manuals for a total of 17 vehicle models.',
    caseItem4Title: 'Working Hours Manual',
    caseItem4Desc: 'We have developed Working Hours Manuals for a total of 17 vehicle models.',
    caseItem5Title: 'Specialty Tools',
    caseItem5Desc: 'We have developed Specialty Tools for a total of 17 vehicle models.',
    caseItem6Title: 'Training Materials and Teaching Aids',
    caseItem6Desc: 'We have developed Training Materials and Teaching Aids for a total of 17 vehicle models.',
    // Service process
    serviceTitle: 'Service Process',
    serviceSubtitle: '',
    // Advantage
    advantageTitle1: 'Business',
    advantageTitle2: 'Philosophy',
    advantageDesc: 'Embracing our core business philosophy of "serving with heart and ensuring results," we are committed to delivering professional and efficient service to our customers.',
    // Partners
    partnerTitle: 'Business Partners',
    partnerSubtitle: '',
    // SEO
    seoTitle: 'Automotive Technical Documentation & Training | ForCarTech',
    seoDescription: 'Professional automotive technical documentation services including user manuals, maintenance manuals, wiring diagrams, diagnostic manuals, spare parts catalogs, 3D simulation training, and multimedia instructional videos. Multi-language translation support.',
    seoKeywords: 'automotive user manual, maintenance manual, wiring diagram, diagnostic manual, spare parts catalog, automotive repair video, CG animation, 3D training system, VR simulation, AR teaching, automotive specialty tools, technical translation',
  },

  // About.vue - About Us
  about: {
    title: 'About Us',
    p1: 'Wuhan ForCarTech Automotive Technology Co., Ltd. is a specialized automotive technology company that offers a comprehensive suite of services, including User manuals, Maintenance Manuals, Wiring Diagram, Service Labor Time, and Parts Catalogs Authoring, Automotive Sectional Structure Diagram, Automotive Instructional Videos Creating, (PC, VR, AR) 3D training system development, Automotive maintenance specialty tools development and production, Automotive cutaways for training and exhibition development, HTML Platform development, 3D model and CG animation development, and Professional Translation（English，Русский，العربية，Español，Português，日本語）',
    p2: 'Wuhan ForCarTech Automotive Technology Co., Ltd. was established on January 25, 2008. It is a specialized automotive technology company that offers a comprehensive suite of services including after-sale technical documentation, spare parts catalog/EPC development, custom tool design and manufacturing, training materials and teaching aids development, maintenance technical information system development, and services for H5 system platforms and mobile apps.',
    p3: 'ForCarTech boasts an elite team with extensive theoretical knowledge and practical experience in automotive after-sales technical maintenance. Adhering to the business philosophy of "Work with dedication, ensure results," we serve our clients with the spirit of professionalism and efficiency.',
    seoTitle: 'Automotive Technical Documentation & Training | ForCarTech',
    seoDescription: 'Professional automotive technical documentation services including user manuals, maintenance manuals, wiring diagrams, diagnostic manuals, spare parts catalogs, 3D simulation training, and multimedia instructional videos. Multi-language translation support.',
    seoKeywords: 'automotive user manual, maintenance manual, wiring diagram, diagnostic manual, spare parts catalog, automotive repair video, CG animation, 3D training system, VR simulation, AR teaching, automotive specialty tools, technical translation',
  },

  // Case.vue - Project Portfolio
  case: {
    title: 'Our Latest Successful Projects',
    desc: 'Tell stories with real cases',
    selectCase: 'Please Select a Case',
    expand: 'More',
    collapse: 'Less',
    categories: [
      'User Manual',
      'Maintenance Manual',
      'Spare Parts Catalog',
      'Circuit Diagram',
      'Disassembly Instruction Manual',
      'Labor Guide Catelog',
      'Automotive Specialty Tools',
      'Training and Teaching Tools',
      'Videos and Animations',
      'Software System',
      'Others',
    ],
    options: [
      'User Manual',
      'Maintenance Manual',
      'Spare Parts Catalog',
      'Circuit Diagram',
      'Disassembly Instruction Manual',
      'Labor Guide Catelog',
      'Automotive Specialty Tools',
      'Training and Teaching Tools',
      'Videos and Animations',
      'Software System',
      'Others',
    ],
    seoTitle: 'Automotive Technical Documentation & Training | ForCarTech',
    seoDescription: 'Professional automotive technical documentation services including user manuals, maintenance manuals, wiring diagrams, diagnostic manuals, spare parts catalogs, 3D simulation training, and multimedia instructional videos. Multi-language translation support.',
    seoKeywords: 'automotive user manual, maintenance manual, wiring diagram, diagnostic manual, spare parts catalog, automotive repair video, CG animation, 3D training system, VR simulation, AR teaching, automotive specialty tools, technical translation',
  },

  // Culture.vue - Our Vision
  culture: {
    sloganTitle: 'Our Vision',
    slogan1: 'Think ahead, look ahead, and go the extra mile to get it right the first time.',
    slogan2: 'Every word must have a source, every word must be chosen with care.',
    philosophyTitle: 'Business Philosophy',
    philosophy: 'Work with Heart, Guarantee the Results.',
    seoTitle: 'Automotive Technical Documentation & Training | ForCarTech',
    seoDescription: 'Professional automotive technical documentation services including user manuals, maintenance manuals, wiring diagrams, diagnostic manuals, spare parts catalogs, 3D simulation training, and multimedia instructional videos. Multi-language translation support.',
    seoKeywords: 'automotive user manual, maintenance manual, wiring diagram, diagnostic manual, spare parts catalog, automotive repair video, CG animation, 3D training system, VR simulation, AR teaching, automotive specialty tools, technical translation',
  },

  // Team.vue - Meet the Team
  team: {
    roles: [
      {
        title: 'Automotive Technology Expert, Senior Engineer',
        desc: "With 35 years of experience in the automotive application and maintenance industry, Feng Chen has personally led and authored a series of usage and maintenance technical materials for Dongfeng Motor Corporation as well as joint venture and independent brands. He has multiple training and seminar experiences in France, Spain, and Sweden. He has published numerous automotive maintenance books with People's Transportation Publishing House and Machinery Industry Publishing House and has written many papers on automotive maintenance. Feng Chen is a leading professional in automotive application at Dongfeng Peugeot-Citroën Automobile Company Ltd (DPCA); an expert receiving a special allowance from the Wuhan Municipal People's Government; a senior engineer expert and judge at DPCA. He has served as an expert member of the National Automobile Maintenance Standardization Committee and a specially appointed expert on national automobile maintenance technical information, participating in the review and revision of related standards by the Ministry of Transport.",
      },
      {
        title: 'Senior Automotive Repair Technician',
        desc: 'With years of experience in automotive 4S shop maintenance, this technician excels in hands-on vehicle repairs, researching practical and feasible repair methods.',
      },
      {
        title: 'Automotive Application Engineer',
        desc: "A bachelor's degree graduate in an automotive-related field, this engineer possesses a solid foundation in automotive theory, practical operational skills, and the ability to analyze malfunctions. They also have strong written communication skills.",
      },
      {
        title: 'Automotive Electrical Engineer',
        desc: 'Graduate in electronics or electrical engineering with a strong foundation in electrical systems. Possesses many years of experience in automotive electrical diagnostics.',
      },
      {
        title: 'Mechanical Engineer',
        desc: 'With many years of experience in tool design and machining, this engineer has specialized expertise in materials, manufacturing processes, and heat treatment.',
      },
      {
        title: 'Senior Graphic Designer',
        desc: 'Committed to the perfect integration of automotive technology and artistry, our graphic design team operates with clear role delineation. We have successfully contributed to the design and production of technical documents and graphic promotional materials for various companies, including Dongfeng Motor Corporation, Dongfeng Passenger Vehicle, Dongfeng Honda, Dongfeng Citroën, Dongfeng Peugeot, Dongfeng Engineering Vehicle, and Dongfeng Shares.',
      },
      {
        title: '3D Animation Designer',
        desc: 'Expert in 3D production software, our 3D Animation Designer brings a high level of proficiency in three-dimensional creation and artistic design. This professional supports our team with exceptional design and production for AR (Augmented Reality) services, demonstrating a thorough understanding of special effects software and mastery over the production pipeline, including modeling, texturing, and rendering. Skilled in the principles of animation motion, the designer has a strong ability to control the tempo of animations, showcasing an excellent sense of visual rhythm, creativity, and imagination.',
      },
      {
        title: 'Programmer',
        desc: 'Our programmer is a developer with extensive experience in front-end development, proficient in HTML and CSS technologies, and well-versed in the Vue framework and Web3D technology. They excel at crafting clear and maintainable code using HTML and CSS, and are adept at employing the Vue framework to create dynamic interactions and responsive designs. With knowledge and skills in Web3D technology, they are capable of integrating 3D scenes and animations into web development, enhancing user experience and the visual impact of web pages.',
      },
      {
        title: 'Text Editor',
        desc: 'A background in Journalism, Chinese Language, or Literature is preferred, with strong writing and verbal communication skills. Knowledge of the automotive industry is a plus, as the role involves reviewing and editing technical documents for clarity and accuracy.',
      },
      {
        title: 'Video Editor',
        desc: 'Capable of video shooting, editing, and post-production tasks.',
      },
      {
        title: 'Quality Supervisor',
        desc: 'Possesses extensive experience in automotive technical documentation development, responsible for the overall quality control of technical documents and specialized tools.',
      },
    ],
    seoTitle: 'Automotive Technical Documentation & Training | ForCarTech',
    seoDescription: 'Professional automotive technical documentation services including user manuals, maintenance manuals, wiring diagrams, diagnostic manuals, spare parts catalogs, 3D simulation training, and multimedia instructional videos. Multi-language translation support.',
    seoKeywords: 'automotive user manual, maintenance manual, wiring diagram, diagnostic manual, spare parts catalog, automotive repair video, CG animation, 3D training system, VR simulation, AR teaching, automotive specialty tools, technical translation',
  },

  // Address.vue - Contact Us
  address: {
    companyName: 'Wuhan ForCarTech Automotive Technology Co., Ltd.',
    contact: 'Chen Feng',
    mobile: '138 0712 1650',
    landline: '152 0270 8329',
    email: 'mail@forcartech.com',
    bizAddress: 'Building 30, Shangyuan Yungu Valley, Fengshu Fifth Road, Dongfeng Avenue, Wuhan Economic and Technological Development Zone',
    qrcode: 'Follow ForCarTech on WeChat',
    seoTitle: 'Automotive Technical Documentation & Training | ForCarTech',
    seoDescription: 'Professional automotive technical documentation services including user manuals, maintenance manuals, wiring diagrams, diagnostic manuals, spare parts catalogs, 3D simulation training, and multimedia instructional videos. Multi-language translation support.',
    seoKeywords: 'automotive user manual, maintenance manual, wiring diagram, diagnostic manual, spare parts catalog, automotive repair video, CG animation, 3D training system, VR simulation, AR teaching, automotive specialty tools, technical translation',
  },

  // Ability3.vue - Credit China / Professional Honor
  ability3: {
    tab1: 'Credit China',
    tab1Title: 'Interview with Credit China CCTV, Feng Chen:One-Stop Service For Automotive After-Sale Technology.',
    tab1Original: 'Original',
    tab1Column: 'Credit China Column',
    tab1Date: '2024/03/04',
    tab1Desc: "With the rapid evolution of the antomotive industry, consumers' demands for vehicle quality, performance,and services are continuously increasing. Against this backdrop, car manufacturers and dealerships must provide professional automotive technical services and innovative marketing strategies to maintain a competitve edge in the fierce market competition.Amidst this wave of change,Mr. Chen, With his profound industy experience an forward-looking vision,has led Wuhan ForCarTech Automotive Technology Co., Ltd. to the forefront of the industry.",
    tab1Link: 'details →',
    tab2: 'Professional Honor',
    tab2Title: 'Honor Conferred: Expert (Member) of the 2nd Automotive Repair Information Disclosure Expert Committee',
    tab2Desc: 'With years of professional accumulation and outstanding contributions in the industry, Comrade Chen Feng has been conferred the honor of "Expert (Member) of the 2nd Automotive Repair Information Disclosure Expert Committee" and officially appointed as a committee member for a three-year term. This honor not only reflects his professional status in the automotive repair field but also signifies his important role in promoting the transparency and standardization of automotive repair information. With his strong industry background and technical expertise, he will continue to make significant contributions in the next three years to drive industry development and improve repair service standards.',
  },

  // router meta titles
  route: {
    about: 'About Us',
    address: 'Contact Us',
    case: 'Project Portfolio',
    culture: 'Our Vision',
    team: 'Our Team',
    bd: 'Baidu Baike',
  },
}
